export default ({ category, label }) => {
  // console.log(category, label)
  if (window.gtag) {
    window.gtag("event", "click", {
      'event_category': category,
      'event_label': label,
    })
  }
}
